interface Props {
  contexto: string;
  motivoBloqueio?: string | null;
  onVoltar?: () => void;
  /** Ausente na revisão: o passo seguinte é o "Solicitar ATF" da própria tela. */
  onAvancar?: () => void;
  rotuloAvancar: string;
  desabilitado?: boolean;
}

/**
 * Barra fixa do rodapé — a recomendação de design do handoff (§2, "barra
 * fixa"). A coluna principal reserva o espaço dela para não cobrir o conteúdo.
 *
 * Os atalhos "ESC" e "ENTER" desenhados nos botões saíram (0094): nenhum dos dois
 * funcionava, e a tecla prometida que não responde ensina a desconfiar da tela.
 */
export function WizardRodape({ contexto, motivoBloqueio, onVoltar, onAvancar, rotuloAvancar, desabilitado }: Props) {
  return (
    <div className="co-rodape">
      <div className="co-rodape-miolo">
        <p className="co-rodape-contexto" data-bloqueio={motivoBloqueio ? '' : undefined} role="status">
          {motivoBloqueio ?? contexto}
        </p>
        <div className="co-rodape-acoes">
          {onVoltar && (
            <button type="button" className="co-btn co-btn-secundario" onClick={onVoltar}>
              Voltar
            </button>
          )}
          {onAvancar && (
            <button type="button" className="co-btn co-btn-primario" onClick={onAvancar} disabled={desabilitado}>
              {rotuloAvancar}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
